import { Injectable, inject } from '@angular/core';
import { Play } from '@r1-compass-library/models';
import { Dependency } from '@r1-compass-library/models/dependencies.model';
import { LifecycleRuleset } from '@r1-compass-library/models/lifecycle-rules/lifecycle-ruleset.model';
import { LifecycleRulesetFolderService } from '@r1-compass-library/services/lifecycle-ruleset-folder.service';
import { LifecycleRulesetService } from '@r1-compass-library/services/lifecycle-ruleset.service';
import { AssetListState, AssetListStore } from '@r1-compass-library/store/asset-list.store';
import { forkJoin } from 'rxjs';
import { PlayService } from '@r1-compass-library/services';

@Injectable()
export class LifecycleRulesetListStore extends AssetListStore<
    LifecycleRuleset,
    LifecycleRulesetService,
    LifecycleRulesetFolderService
> {
    readonly #playService = inject(PlayService);

    protected override initialState: AssetListState<LifecycleRuleset> = {
        assets: [],
        folders: [],
        currentFolder: null,
        dependencies: undefined,
        message: undefined,
    };

    assetTypeName = 'Lifecycle Ruleset Folder';

    constructor(
        lifecycleRulesService: LifecycleRulesetService,
        lifecycleRulesFoldersService: LifecycleRulesetFolderService
    ) {
        super(lifecycleRulesService, lifecycleRulesFoldersService);
    }

    protected override handleDependencies(assets: LifecycleRuleset[]) {
        this.clearDependencies();
        forkJoin(assets.map(asset => this.#playService.search({ lifecycleRulesetId: asset.id }))).subscribe(plays => {
            this.setDependenciesForAssets(plays, assets);
        });
    }

    protected override buildDependencies(play: Play, assets: LifecycleRuleset[]): Dependency[] {
        return [
            {
                assetId: play.lifecycleRulesetId ?? undefined,
                playId: play.id,
                name: play.name,
            },
        ];
    }
}
